import { useState } from "react";
import SEO from "../shared/SEO";
import logo from '../../src/assets/logo.png'
import map from '../../assets/map.png'
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { FaLinkedinIn, FaInstagram, FaXTwitter, FaFacebookF } from "react-icons/fa6";
import Navbar from "./Navbar";
import Footer from "./Footer";
const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <div className="bg-white">
      <SEO
        title="Contact Orcas Valley | Let's Build Your Startup"
        description="Have questions or ready to start? Contact Orcas Valley to build, pitch, and fund your startup with expert support."
        url="https://orcasvalley.web.app/contact-us"
        keywords="contact startup accelerator, talk to startup advisors, startup consultation, business support, entrepreneur help"
      />
              <Navbar />
              <header className="relative text-white text-center sm:text-left h-[85vh] flex items-center justify-center px-6 sm:px-10">
  {/* Background Image */}
  <div className="absolute inset-0 px-6 sm:px-10">
    <div 
      className="w-full h-full bg-cover bg-center rounded-xl"
      style={{ backgroundImage: "url('/ContactUs.png')" }}
    ></div>
  </div>

  {/* Dark Overlay for Readability */}
  <div className="absolute inset-0 bg-white  bg-opacity-5  rounded-xl"></div>

  {/* Content Container */}
  <div className="relative z-10 w-full flex items-center justify-center sm:justify-start p-4">
    {/* Main Content */}
    <div className="px-4 sm:px-20 mt-32 sm:mt-52">
      <h1 className="text-4xl sm:text-6xl font-bold leading-tight">Contact Orcas Valley Startup Accelerator</h1>
      <p className="mt-4 text-base sm:text-lg text-gray-300">
        Ready to start? Contact startup accelerator advisors to build, pitch, and fund <br className="hidden sm:block"/> 
        your startup with expert support. Have questions about our startup platform? <br className="hidden sm:block"/> 
        We'd love to help you transform your vision into reality.
      </p>
    </div>
  </div>

  {/* Side Text (Vertical) - Only Visible on Desktop */}
  <div className="absolute top-6 left-3 sm:top-10  xs:left-2 sm:left-6 md:left-10  z-20 px-5 flex flex-col items-center text-gray-300 text-lg tracking-widest  sm:flex">
    <div className="border-l-2 border-gray-300 h-6 sm:h-10 mb-1 sm:mb-2"></div>
    <p className="flex flex-col text-center text-xs">
    <span>T</span>
      <span>H</span>
      <span>E</span>
      <br />
      <span>O</span>
      <span>R</span>
      <span>C</span>
      <span>A</span>
      <span>S</span>
      <br />
      <span>W</span>
      <span>A</span>
      <span>Y</span>
    </p>
  </div>
</header>

     

      {/* Contact Section */}
       <div className="max-w-6xl mx-auto px-4 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
     <div className="bg-gray-100 p-6 sm:p-8 rounded-md shadow-sm">
  <h2 className="text-2xl sm:text-3xl font-light text-gray-800 mb-6 border-b pb-2">Contact us</h2>
  <form onSubmit={handleSubmit} className="space-y-6">
    
    <div className="relative">
      <label className="absolute -top-2 left-3 bg-white border border-gray-100 text-gray-700 text-sm  rounded-xl px-3 py-1">
        Name
      </label>
      <input
      title='text'
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        className="w-full p-4 pt-6 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#02C4A1] text-gray-800"
        required
      />
    </div>

    <div className="relative">
      <label className="absolute -top-2 left-3 bg-white border border-gray-100 text-gray-700 text-sm  rounded-xl px-3 py-1">
        Email ID
      </label>
      <input
      title="email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        className="w-full p-4 pt-6 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#02C4A1] text-gray-800"
        required
      />
    </div>

    <div className="relative">
      {/* <label className="absolute -top-2 left-3 bg-white border border-gray-100 text-gray-700 text-sm  rounded-xl px-3 py-1">
        Message
      </label> */}
      <textarea
      title="message"
        name="message"
        placeholder="Write your message"
        value={formData.message}
        onChange={handleChange}
        className="w-full p-4 pt-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#02C4A1] text-gray-800 resize-none"
        rows={5}
        required
      />
    </div>

    <button className="px-6 py-2 bg-[#02C4A1] hover:bg-[#072928] text-white rounded-full font-light flex items-center space-x-2 shadow-md transition">
      <span>Submit</span>
      <span className="text-lg">→</span>
    </button>
  </form>
</div>


        <div className="bg-gray-100 p-6 sm:p-8 rounded-md shadow-sm flex flex-col justify-between h-[90%]">
          <div>
            <h2 className="text-2xl sm:text-3xl font-light text-gray-800 mb-4 border-b pb-2">Find us</h2>
            <div className="w-full h-48 rounded-lg overflow-hidden border border-gray-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.864326474389!2d0.05178!3d51.53824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a77a9e5a5a5d%3A0x5d5d5d5d5d5d5d5d!2s182-184%20High%20St%20N%2C%20East%20Ham%2C%20London%20E6%202JA%2C%20UK!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Office Location Map"
              ></iframe>
            </div>
            
            {/* Location */}
            <div className="mt-6 flex items-start space-x-3 text-gray-700">
              <FaMapMarkerAlt className="text-[#02C4A1] text-xl mt-1 flex-shrink-0" />
              <div>
                <p className="font-semibold text-gray-800">Location</p>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=Office+8815WC+182-184+High+Street+North+East+Ham+London+E6+2JA" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm sm:text-base hover:text-[#02C4A1] transition-colors cursor-pointer"
                  title="View on Google Maps"
                >
              London,UK
                </a>
              </div>
            </div>
          </div>

          {/* Contact Details */}
          <div className="mt-6">
            <div className="flex items-center space-x-3 text-gray-700 mb-3">
              <FaPhoneAlt className="text-[#02C4A1] flex-shrink-0" />
              <a href="tel:+447451250194" className="hover:text-[#02C4A1] transition-colors">
               +44 7 451250194
              </a>
            </div>
            <div className="flex items-center space-x-3 text-gray-700 mb-4">
              <FaEnvelope className="text-[#02C4A1] flex-shrink-0" />
              <a href="mailto:support@orcasvalley.com" className="hover:text-[#02C4A1] transition-colors">
                support@orcasvalley.com
              </a>
            </div>
            
            {/* Follow us on */}
            <div className="flex items-center">
              <span className="text-gray-600 text-sm sm:text-base mr-2">Follow us on:</span>
              <div className="flex-1 border-b border-gray-300"></div>
              <div className="ml-4 flex space-x-3">
                <a href="https://www.linkedin.com/company/orcas-valley" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-[#02C4A1] transition-colors"><FaLinkedinIn className="w-5 h-5" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactUs;
